/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ScoreLabel.vue?vue&type=template&id=bb0f8f0e"
import script from "./ScoreLabel.vue?vue&type=script&lang=js"
export * from "./ScoreLabel.vue?vue&type=script&lang=js"
import style0 from "./ScoreLabel.vue?vue&type=style&index=0&id=bb0f8f0e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports